import gql from "graphql-tag";

export const LIST_LABELS = gql`
  query getLabels {
    getLabels
  }
`;
